import { RouteObject } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import ManageContact from '~/modules/myAccount/pages/ManageContact';

const routes: RouteObject[] = [
  {
    path: `${RoutesEnum.MANAGE_CONTACT}`,
    element: <ManageContact />,
  },
];
export default routes;
